<template>
  <div>
    <a @click.stop="toggleStar" :class="'fa ' + faStar + ' star'" class="dash-color-skin cursor-pointer"></a>
  </div>
</template>  

<script>
export default {
  name: 'contact-fav',
  data () {
    return {
      checkVal: this.value
    }
  },
  watch: {
    value () {
      this.checkVal = this.value
    }
  },
  computed: {
    faStar () {
      if (this.checkVal === 'Y') {
        return 'fa-star'
      } else {
        return 'fa-star-o'
      }
    }
  },
  props: ['value', 'postContactFavorite', 'codempid'],
  methods: {
    toggleStar () {
      if (this.checkVal === 'Y') {
        this.checkVal = 'N'
      } else {
        this.checkVal = 'Y'
      }
      this.postContactFavorite({ codempid_fav: this.codempid, flg_fav: this.checkVal })
      this.$emit('input', this.checkVal)
    }
  }
}
</script>



// WEBPACK FOOTER //
// contactFav.vue?699a7344